import { CountryRiskBadgesProps } from 'modules/client/common/feature';

export interface BeneficiaryItem {
  id: string;
  name: string;
  email: string;
  country: string;
  countryRisk?: CountryRiskBadgesProps;
  capitalParticipationPercentage: number;
  archived: boolean;
}
export enum BeneficiaryOptionType {
  delete = 'delete',
  archive = 'archive',
  dearchive = 'dearchive',
}

export interface BeneficiaryColumnArgs {
  shownOptions?: Partial<Record<BeneficiaryOptionType, boolean>>;
  editable?: boolean;
  enabledCityColumn?: boolean;
  onClickOption: (item: BeneficiaryItem, option: BeneficiaryOptionType) => void;
}
